// extracted by css-extract-rspack-plugin
export default {"size200":"200px","smallColumn":"basic-job-details__smallColumn___ZBYj_"};